export const MAX_DATE_MASK_SAFE_GUARD: string = '9999-12-31';
